import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getPlantillasConsentimientos = query =>
	fetch.get(
		`/plantillas-consentimientos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);

export const getPlantillaConsentimiento = (id, query) =>
	fetch.get(
		`/plantillas-consentimientos/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addPlantillaConsentimiento = data =>
	fetch.post('/plantillas-consentimientos', data);
export const updatePlantillaConsentimiento = ({ id, ...data }) =>
	fetch.put(`/plantillas-consentimientos/${id}`, data);
export const deletePlantillaConsentimiento = id =>
	fetch.delete(`/plantillas-consentimientos/${id}`);

// RTK Query
export const plantillasConsentimientosApi = createApi({
	reducerPath: 'plantillasConsentimientosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getPlantillasConsentimientos: build.query({
			query: query => {
				return {
					url: `/plantillas-consentimientos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'PlantillasConsentimientos',
								id,
							})),
							{ type: 'PlantillasConsentimientos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'PlantillasConsentimientos', id: 'LIST' }],
		}),
		getLastPlantillaConsentimiento: build.query({
			query: query => {
				return {
					url: `/plantillas-consentimientos/last-active`,
					method: 'GET',
					headers: {
						Authorization: 'public', // remove authorization header
					},
				};
			},
			transformResponse: response => response.data,
			providesTags: () => [
				{ type: 'PlantillasConsentimientos', id: 'LAST' },
			],
		}),
		getPlantillaConsentimiento: build.query({
			query: ({ id, query }) => {
				return {
					url: `/plantillas-consentimientos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [
				{ type: 'PlantillasConsentimientos', id },
			],
		}),
		addPlantillaConsentimiento: build.mutation({
			query: body => ({
				url: `/plantillas-consentimientos`,
				method: 'POST',
				body: { data: body },
			}),
			transformResponse: response => response.data,
			invalidatesTags: [{ type: 'PlantillasConsentimientos', id: 'LIST' }],
		}),
		updatePlantillaConsentimiento: build.mutation({
			query: ({ id, ...body }) => ({
				url: `/plantillas-consentimientos/${id}`,
				method: 'PUT',
				body: { data: body },
			}),
			transformResponse: response => response.data,
			invalidatesTags: (result, error, { id }) => [
				{ type: 'PlantillasConsentimientos', id },
				{ type: 'PlantillasConsentimientos', id: 'LIST' },
			],
		}),
		deletePlantillaConsentimiento: build.mutation({
			query: id => ({
				url: `/plantillas-consentimientos/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: (result, error, id) => [
				{ type: 'PlantillasConsentimientos', id },
				{ type: 'PlantillasConsentimientos', id: 'LIST' },
			],
		}),
	}),
});

export const {
	useGetPlantillasConsentimientosQuery,
	useGetLastPlantillaConsentimientoQuery,
	useGetPlantillaConsentimientoQuery,
	useAddPlantillaConsentimientoMutation,
	useUpdatePlantillaConsentimientoMutation,
	useDeletePlantillaConsentimientoMutation,
} = plantillasConsentimientosApi;

export default plantillasConsentimientosApi;
